import Cookies from "universal-cookie";

// Opens the in-app support form (api-v2 /reports/support-ticket/) with the
// logged-in user's token. Filing happens server-side through the Zendesk API,
// so tickets are never suspended as anonymous.
//
// Must be a top-level navigation, not an ExternalFrame iframe: api-v2 is on a
// different registrable domain than this SPA, so inside a frame its session
// cookie is third-party. Browsers that block those drop the login and
// @staff_member_required bounces the user to the Django admin login page.
const CustomZendeskButton = () => {
  const openSupportForm = () => {
    const accessToken = new Cookies().get("accessToken");

    const params = new URLSearchParams();
    if (accessToken) params.append("token", accessToken);
    params.append("path", "/reports/support-ticket/");

    const baseUrl =
      process.env.REACT_APP_EXTERNAL_FRAME_URL || "http://localhost:9000";
    window.open(
      `${baseUrl}/iframe-redirect/?${params.toString()}`,
      "_blank",
      "noopener"
    );
  };

  return (
    <button onClick={openSupportForm} className="helpButton">
      Need help? Click here
    </button>
  );
};

export default CustomZendeskButton;
